"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = require("@emotion/react");

var _util = require("../../util");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var withIconHiddenStyles = /*#__PURE__*/(0, _react.css)("padding-left:", (0, _util.rem)(16), ";padding-right:", (0, _util.rem)(44), ";min-height:", (0, _util.rem)(40), ";&>button{right:", (0, _util.rem)(16), ";}" + (process.env.NODE_ENV === "production" ? "" : ";label:withIconHiddenStyles;"));
var withoutCloseBtnStyles = /*#__PURE__*/(0, _react.css)("padding-right:", (0, _util.rem)(16), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:withoutCloseBtnStyles;"));

var base = function base(_ref) {
  var theme = _ref.theme,
      withIconHidden = _ref.withIconHidden,
      withCloseBtn = _ref.withCloseBtn;
  return /*#__PURE__*/(0, _react.css)("display:flex;align-items:center;padding:", (0, _util.rem)(9), " ", (0, _util.rem)(40), " ", (0, _util.rem)(8), " ", (0, _util.rem)(12), ";box-shadow:0 1px 3px 0 rgba(", theme.color.monochrome.black_rgba, ", 0.15);border-radius:", (0, _util.rem)(6), ";position:relative;transition:margin 0.3s;&>span{line-height:0;svg{width:", (0, _util.rem)(24), ";height:", (0, _util.rem)(24), ";margin-right:", (0, _util.rem)(12), ";}}&>button{position:absolute;right:", (0, _util.rem)(12), ";top:", (0, _util.rem)(12), ";cursor:pointer;display:flex;align-items:center;svg{width:", (0, _util.rem)(16), ";height:", (0, _util.rem)(16), ";color:", theme.color.monochrome.mediumDark, ";}&:hover svg{color:", theme.color.monochrome.dark, ";}}", withIconHidden && withIconHiddenStyles, ";", !withCloseBtn && withoutCloseBtnStyles, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:base;"));
};

var info = function info(_ref2) {
  var theme = _ref2.theme,
      otherProps = (0, _objectWithoutProperties2["default"])(_ref2, ["theme"]);
  return /*#__PURE__*/(0, _react.css)(base(_objectSpread({
    theme: theme
  }, otherProps)), ";color:", theme.color.primary.brand, ";background-color:", theme.color.secondary.brand, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:info;"));
};

var negative = function negative(_ref3) {
  var theme = _ref3.theme,
      otherProps = (0, _objectWithoutProperties2["default"])(_ref3, ["theme"]);
  return /*#__PURE__*/(0, _react.css)(base(_objectSpread({
    theme: theme
  }, otherProps)), ";color:", theme.color.primary.negative, ";background-color:", theme.color.secondary.negative, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:negative;"));
};

var warning = function warning(_ref4) {
  var theme = _ref4.theme,
      otherProps = (0, _objectWithoutProperties2["default"])(_ref4, ["theme"]);
  return /*#__PURE__*/(0, _react.css)(base(_objectSpread({
    theme: theme
  }, otherProps)), ";color:", theme.color.warning[700], ";background-color:", theme.color.secondary.warning, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:warning;"));
};

var positive = function positive(_ref5) {
  var theme = _ref5.theme,
      otherProps = (0, _objectWithoutProperties2["default"])(_ref5, ["theme"]);
  return /*#__PURE__*/(0, _react.css)(base(_objectSpread({
    theme: theme
  }, otherProps)), ";color:", theme.color.primary.positive, ";background-color:", theme.color.secondary.positive, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:positive;"));
};

var white = function white(_ref6) {
  var theme = _ref6.theme,
      otherProps = (0, _objectWithoutProperties2["default"])(_ref6, ["theme"]);
  return /*#__PURE__*/(0, _react.css)(base(_objectSpread({
    theme: theme
  }, otherProps)), ";color:", theme.color.primary.positive, ";background-color:", theme.color.monochrome.white, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:white;"));
};

var styles = {
  info: info,
  warning: warning,
  negative: negative,
  positive: positive,
  white: white
};
exports.styles = styles;
//# sourceMappingURL=MessageCard.styles.js.map